import { Row } from "@tanstack/react-table";
import { FileText } from "lucide-react";

import { useToolsOnSiteTableColumns } from "./OnSiteTableColumns";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import { PROJECT_CONSTANTS } from "@/constants/projects.constant";
import { ToolsKeys } from "@/constants/tools.constant";
import useQueryID from "@/hooks/useQueryId";
import { IProductAssignment } from "@/interfaces/tools.interface";

interface AssignToolsOnSiteTableProps {
  data: IProductAssignment[];
  toggleCommentSheet: () => void;
}

const AssignToolsOnSiteTable = ({
  data,
  toggleCommentSheet,
}: AssignToolsOnSiteTableProps): JSX.Element => {
  const { set } = useQueryID(ToolsKeys.PRODUCT_ASSIGNMENT_ID);
  const { ASSIGN_TOOLS_CONSTANTS } = PROJECT_CONSTANTS;

  const getActionOptions = (
    row: Row<IProductAssignment>,
  ): ActionButtonDataTypes[] => {
    const defaultActions: ActionButtonDataTypes[] = [
      {
        icon: FileText,
        name: "Comments",
        onclick: (): void => {
          set(row.original.id);
          toggleCommentSheet();
        },
      },
    ];

    return defaultActions;
  };

  const columns = useToolsOnSiteTableColumns({
    getActionOptions,
  });

  return (
    <div>
      <CustomTable
        data={data}
        columns={columns}
        empty={{}}
        title={ASSIGN_TOOLS_CONSTANTS.CONTENT_TEXT.ONSITE}
        hide={{
          filters: true,
          functions: true,
        }}
      />
    </div>
  );
};

export default AssignToolsOnSiteTable;
